import React from 'react'
import { Link } from 'react-router-dom'

export default function Logo({ variant = 'dark', className = '' }) {
  const isLight = variant === 'light'
  
  return (
    <Link to="/" className={`group inline-flex items-center gap-3 focus:outline-none ${className}`}>
      <img
        src="https://assets.auxodev.dk/cdn-cgi/image/width=360,format=auto,quality=90/assets/070d40dc-3ad7-4f6e-9a43-382bc6e79eb3/transport4u-logov2.webp"
        srcSet="https://assets.auxodev.dk/cdn-cgi/image/width=240,format=auto,quality=90/assets/070d40dc-3ad7-4f6e-9a43-382bc6e79eb3/transport4u-logov2.webp 240w, https://assets.auxodev.dk/cdn-cgi/image/width=360,format=auto,quality=90/assets/070d40dc-3ad7-4f6e-9a43-382bc6e79eb3/transport4u-logov2.webp 360w, https://assets.auxodev.dk/cdn-cgi/image/width=480,format=auto,quality=90/assets/070d40dc-3ad7-4f6e-9a43-382bc6e79eb3/transport4u-logov2.webp 480w"
        sizes="(max-width: 640px) 180px, 240px"
        alt="Transport4U"
        className={`h-12 sm:h-14 md:h-15 w-auto max-w-[210px] sm:max-w-[250px] md:max-w-[280px] object-contain transition-transform duration-200 group-hover:scale-[1.02] ${
          isLight ? 'bg-white rounded-xl p-2 shadow-xs' : ''
        }`}
      />
    </Link>
  )
}
